<!--  -->
<template>
  <div class='update-page'>
    <nav-title title="商品入库"></nav-title>
    <main>
      <van-form @submit="handleAffirm" ref="form">
        <div class="form-item">
          <span>商品名称<span>*</span></span>
          <van-field
            name="goods_name"
            clearable
            v-model="dataForm.goods_name"
            placeholder="请输入商品名称"
            type="text"
            :rules="[
              {required: true},
            ]"
          />
        </div>
        <div class="form-item">
          <span>商品分类<span>*</span></span>
          <van-field
            name="category_id"
            is-link
            readonly
            v-model="fieldValue"
            placeholder="请选择商品分类"
            type="text"
            @click="show = true"
            :rules="[
              {required: true},
            ]"
          />
        </div>
        <div class="form-item">
          <span>商品价格<span>*</span></span>
          <van-field
            name="goods_price"
            clearable
            v-model="dataForm.goods_price"
            placeholder="请输入商品价格"
            type="number"
            :rules="[
              {required: true},
            ]"
          />
        </div>
        <div class="form-item images">
          <span>商品图片<span>*</span></span>
          <main>
            <template v-if="dataForm.images.length > 0">
              <div class="image" v-for="(item, index) in images" :key="index">
                <template v-if="item">
                  <img :src="item" alt="">
                  <div class="del" @click="dataForm.images.splice(index, 1);images.splice(index, 1)">
                    <van-icon name="cross"></van-icon>
                  </div>
                </template>
                <van-loading size="24px" vertical v-else>加载中...</van-loading>
              </div>
            </template>
            <van-uploader :after-read="afterReadInfo">
              <div class="file-def">
                <img src="~@/assets/image/xiangji2.png" alt="">
                <span>添加图片</span>
              </div>
            </van-uploader>
          </main>
        </div>
        <div class="form-item">
          <span>当前库存<span>*</span></span>
          <van-field
            name="stock_num"
            clearable
            v-model="dataForm.stock_num"
            placeholder="请输入当前库存"
            type="digit"
            :rules="[
              {required: true},
            ]"
          />
        </div>
        <div class="form-item">
          <span>仓储位置<span>*</span></span>
          <van-field
            name="goods_address"
            clearable
            v-model="dataForm.goods_address"
            placeholder="请输入仓储位置"
            type="text"
            :rules="[
              {required: true},
            ]"
          />
        </div>
        <div class="form-item textarea">
          <span>商品详情<span>*</span></span>
          <van-field
            clearable
            autosize
            rows="4"
            type="textarea"
            v-model="dataForm.content"
            placeholder="请输入商品详情"
            :rules="[
              {required: true},
            ]"
          />
        </div>
      </van-form>
    </main>
    <footer>
      <div class="footer-btn-red" @click="$refs.form.submit()">保存</div>
    </footer>

    <van-popup v-model="show" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择分类"
        :options="category_list"
        :field-names="{
          text: 'category_name',
          value: 'category_id',
          children: 'child',
        }"
        @close="show = false"
        @finish="onFinish"
      />
    </van-popup>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      show: false,
      fieldValue: '',
      cascaderValue: '',
      category_list: [],
      images: [],
      dataForm: {
        goods_name: '',
        category_id: '',
        goods_price: '',
        images: [],
        stock_num: '',
        goods_address: '',
        content: '',
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getCategory()
  },
  mounted() {
    
  },
  beforeDestroy() {
    
  },
  //方法集合
  methods: {
    // 获取分类数据
    getCategory () {
      this.$http({
        method: 'post',
        data: {
          c: 'goods/category_list',
          category_id: 0
        }
      }).then(res => {
        if (res.code == 200) {
          this.category_list = res.data
        } else {
          this.$toast.fail(res.message || '分类数据获取失败')
        }
      })
    },
    // 选择分类
    onFinish ({ selectedOptions }) {
      this.show = false;
      this.fieldValue = selectedOptions.map((option) => option.category_name).join('/');
      this.dataForm.category_id = [selectedOptions.map((option) => option.category_id)]
    },
    // 上传图片
    afterReadInfo (file) {
      let idx = this.images.length
      this.$set(this.images, idx, '')
      this.$http({
        method: 'post',
        data: {
          c: 'goods/image',
          iFile: file.content
        }
      }).then(res => {
        if (res.code == 200) {
          this.$set(this.dataForm.images, idx , res.data.file_id)
          this.$set(this.images, idx , res.data.file_path)
        } else {
          this.dataForm.images.splice(idx, 1)
          this.images.splice(idx, 1)
          this.$toast.fail(res.message)
        }
      })
    },
    // 提交
    handleAffirm () {
      if (this.dataForm.images.length == 0) {
        this.$notify({ type: 'danger', message: '请上传商品图片'});
        return;
      }
      let over = true
      this.images.forEach(item => {
        if(!item) {
          over = false
        }
      })
      if (!over) {
        this.$toast.loading({
          message: '文件上传中，请稍后',
          forbidClick: true,
        });
        return;
      }
      let form = Object.assign({
        c: 'goods/add_goods',
        goods: this.dataForm
      }, {})
      this.$http({
        method: 'post',
        data: form
      }).then(res => {
        if (res.code == 10006) {
          this.$toast({
            message: '保存成功',
            className: 'set-toast'
          })
          this.$router.back(1)
        } else {
          this.$toast.fail(res.message || '操作失败')
        }
      })
    }
  },
}
</script>

<style lang='less' scoped>
.update-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #FAFAFA;
  > main {
    flex: 1;
    padding: 15px;
    overflow: hidden;
    background-color: #fff;
    overflow-y: auto;
    .form-item {
      overflow: hidden;
      display: flex;
      align-items: center;
      padding-bottom: 15px;
      border-bottom: 0.5px solid rgba(229, 229, 229, 0.51);
      margin-bottom: 15px;
      &:last-child {
        border-bottom: 0px;
        margin-bottom: 0px;
        padding-bottom: 0px;
      }
      > span {
        width: 99px;
        font-size: 16px;
        display: block;
        > span {
          color: #E73F22;
        }
      }
      .van-cell  {
        flex: 1;
        overflow: visible;
        background-color: transparent;
        /deep/ .van-field__error-message {
          position: absolute;
          top: 100%;
          left: 0;
        }
      }
      > main {
        display: flex;
        gap: 5px 10px;
        flex-wrap: wrap;
        margin-top: 7px;
        .file-def {
          width: 98px;
          height: 98px;
          border-radius: 6px;
          background-color: #FAFAFA;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          > img {
            width: 34px;
            height: 34px;
            margin-bottom: 4px;
          }
          > span {
            font-size: 10px;
            color: #9B9E9D;
          }
        }
        .image {
          width: 98px;
          height: 98px;
          border-radius: 6px;
          overflow: visible;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #FAFAFA;
          position: relative;
          > img {
            max-width: 100%;
            max-height: 100%;
          }
          .del {
            width: 16px;
            height: 16px;
            line-height: 16px;
            border-radius: 4px;
            text-align: center;
            border-radius: 50%;
            color: #fff;
            background: red;
            position: absolute;
            top: -6px;
            right: -6px;
          }
        }
      }
    }
    .textarea {
      flex-wrap: wrap;
      .van-cell {
        flex: auto;
        width: 100%;
        border-radius: 6px;
        border: 1px solid #F1F1F2;
        padding: 8px 12px;
        margin-top: 10px;
        overflow-y: auto;
      }
    }
    .images {
      align-items: flex-start;
    }
  }
  > footer {
    padding: 10px 15px;
    display: flex;
    align-items: center;
    > div {
      width: 100%;
      text-align: center;
    }
  }
}
</style>